"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@ceramicnetwork/common");
const docid_1 = __importDefault(require("@ceramicnetwork/docid"));
const utils_1 = require("./utils");
class Document extends common_1.Doctype {
    constructor(state, context, _apiUrl, config = { docSyncEnabled: false }) {
        super(state, context);
        this._apiUrl = _apiUrl;
        this._syncEnabled = config.docSyncEnabled;
        this._syncInterval = config.docSyncInterval;
        if (this._syncEnabled) {
            this._syncPeriodically();
        }
    }
    async _syncState() {
        const { state } = await utils_1.fetchJson(this._apiUrl + '/documents/' + this.id.toString());
        if (JSON.stringify(common_1.DoctypeUtils.serializeState(this.state)) !== JSON.stringify(state)) {
            this.state = common_1.DoctypeUtils.deserializeState(state);
            this.emit('change');
        }
    }
    async _syncPeriodically() {
        while (this._syncEnabled) {
            try {
                await this._syncState();
            }
            catch (e) {
            }
            await utils_1.delay(this._syncInterval);
        }
    }
    get id() {
        return new docid_1.default(this.state.doctype, this.state.log[0].cid);
    }
    static async createFromGenesis(apiUrl, doctype, genesis, context, docOpts = {}, config) {
        const { state } = await utils_1.fetchJson(apiUrl + '/documents', {
            method: 'post',
            body: {
                doctype,
                genesis: common_1.DoctypeUtils.serializeCommit(genesis),
                docOpts,
            }
        });
        return new Document(common_1.DoctypeUtils.deserializeState(state), context, apiUrl, config);
    }
    static async applyCommit(apiUrl, docId, commit, context, docOpts = {}) {
        docId = utils_1.typeDocID(docId);
        const { state } = await utils_1.fetchJson(apiUrl + '/commits', {
            method: 'post',
            body: {
                docId: docId.toString(),
                commit: common_1.DoctypeUtils.serializeCommit(commit),
                docOpts,
            }
        });
        return new Document(common_1.DoctypeUtils.deserializeState(state), context, apiUrl);
    }
    static async load(docId, apiUrl, context, config) {
        docId = utils_1.typeDocID(docId);
        const { state } = await utils_1.fetchJson(apiUrl + '/documents/' + docId.toString());
        return new Document(common_1.DoctypeUtils.deserializeState(state), context, apiUrl, config);
    }
    static async loadDocumentCommits(docId, apiUrl) {
        docId = utils_1.typeDocID(docId);
        const { commits } = await utils_1.fetchJson(apiUrl + '/commits/' + docId.toString());
        return commits.map((r) => {
            return {
                cid: r.cid, value: common_1.DoctypeUtils.deserializeCommit(r.value)
            };
        });
    }
    async change(params, opts) {
        const doctype = new this.doctypeLogic(this.state, this.context);
        await doctype.change(params, opts);
        this.state = doctype.state;
    }
    close() {
        this._syncEnabled = false;
    }
}
exports.default = Document;
//# sourceMappingURL=document.js.map